module.exports = __webpack_public_path__ + "static/media/antiflash.5b163c4b.png";